import type { NavigateOptions } from "@tanstack/react-router"
import type { ReactNode } from "react"
import type { EntityLink } from "./model"
import { EvaluationTab } from "@/common/model"

export default ({
  type,
  id,
  tenantSlug,
  label,
}: EntityLink): NavigateOptions & { children: ReactNode } => {
  switch (type) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    case "dataset":
      return {
        to: "/t/$tenantSlug/evaluations/$id",
        params: { tenantSlug, id },
        search: { evaluationTab: EvaluationTab.Dataset },
        children: label,
      }
  }
}
